import { combineReducers } from 'redux'

import reference from './jobtools/reference.js'
import resume from './jobtools/resume.js'
import letter from './jobtools/letter.js'
import formats from './jobtools/documentformats.js'

const reducers = combineReducers({
  formats,
  reference,
  letter,
  resume
})

export default reducers
